import Close from '@mui/icons-material/Close'
import { IconButton, styled } from '@mui/material'
import { closeSnackbar, MaterialDesignContent, SnackbarKey, SnackbarProvider, SnackbarProviderProps } from 'notistack'
import { FC, PropsWithChildren } from 'react'

/**
 * Will only render an outlet if the user has the required scopes.
 * Otherwise, the user will see the UnauthorizedPage.
 */
export const StyledSnackbarProvider: FC<PropsWithChildren<SnackbarProviderProps>> = ({ children, ...rest }) => {
  const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
    '&.notistack-MuiContent-success': {
      color: 'var(--text-inverted)',
      backgroundColor: 'var(--text-primary)',
      '& .MuiSvgIcon-root': {
        color: 'var(--text-inverted)'
      }
    },
    '&.notistack-MuiContent-error': {
      color: 'var(--text-inverted)',
      backgroundColor: 'var(--text-primary)',
      '& .MuiSvgIcon-root': {
        color: 'var(--text-inverted)'
      }
    },
    '&.notistack-MuiContent-info': {
      color: 'var(--text-inverted)',
      backgroundColor: 'var(--text-primary)',
      '& .MuiSvgIcon-root': {
        color: 'var(--text-inverted)'
      }
    },
    '&.notistack-MuiContent-warning': {
      color: 'var(--text-inverted)',
      backgroundColor: 'var(--text-primary)',
      '& .MuiSvgIcon-root': {
        color: 'var(--text-inverted)'
      }
    }
  }))

  return (
    <SnackbarProvider
      maxSnack={3}
      action={(key: SnackbarKey) => (
        <IconButton onClick={() => closeSnackbar(key)} aria-label={'dismiss'} sx={{ color: 'white' }}>
          <Close />
        </IconButton>
      )}
      Components={{
        success: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent
      }}
      {...rest}
    >
      {children}
    </SnackbarProvider>
  )
}
